import { applyMiddleware, combineReducers, createStore } from "@reduxjs/toolkit";
import { thunk } from "redux-thunk";
import authReducer from "./Reducers/AuthReducer";
import usersProfileReducer from "./Reducers/UsersProfileReducer";
import PaymentReducer from "./Reducers/PaymentReducer";

const rootReducer = combineReducers({
    Auth: authReducer,
    UsersProfile: usersProfileReducer, //other users profiles
    Payment: PaymentReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;